<template>
    <confirmation @interact="onInteractive">
        <template #text> 開啟音效<br />獲得最佳互動體驗 </template>
    </confirmation>
</template>

<script>
import Confirmation from './Confirmation.vue';

export default {
    components: { Confirmation },
    methods: {
        onInteractive(open) {
            this.$emit('interact', open);
        },
    },
};
</script>
